import { styled } from "@mui/material/styles";
import MuiButton from "@mui/material/Button";

export const CustomButton = styled(MuiButton)((props) => ({
    borderRadius: "30px",
    background: 'linear-gradient(to right,#21d4fd,#b721ff)',
    lineHeight: "2",
    fontSize: "15px",
    width: '100%'
}));